import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { API, CompanyDTO, MediumGroupFolderDTO, MediumGroupFullDTO } from '../../../../services/api/api';
import { ErrorService } from '../../../../services/error.service';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { UtilService } from '../../../../services/util.service';
import { UserService } from '../../../../services/user.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CompaniesComponent } from '../../../company/companies/companies.component';
import { MediumGroupFullDTOAndTags } from '../../../../models/taggable.model';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-medium-group-settings-edit',
  templateUrl: './medium-group-settings-edit.component.html',
  styleUrls: ['./medium-group-settings-edit.component.scss'],
  standalone: false,
})
export class MediumGroupSettingsEditComponent implements OnInit {
  @Input() mediumGroup: MediumGroupFullDTOAndTags;
  @Input() selectedFolder: MediumGroupFolderDTO;

  @Output() mediumGroupChangedEmitter: EventEmitter<MediumGroupFullDTO>;
  loading: boolean;
  customer: CompanyDTO;

  form: UntypedFormGroup;

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public modal: ModalService,
    public util: UtilService,
    private userService: UserService,
    private destroyRef: DestroyRef
  ) {
    this.form = new UntypedFormGroup({
      Name: new UntypedFormControl('', [Validators.required]),
      Description: new UntypedFormControl('', []),
    });
    this.loading = true;
    this.mediumGroupChangedEmitter = new EventEmitter<MediumGroupFullDTO>();
    this.userService.selectedCompany.subscribe((company: CompanyDTO) => {
      if (company) {
        this.customer = company;
      } else {
        // if no company then client company
        this.customer = this.userService.user.client.primaryCompany;
      }
    });
  }

  ngOnInit(): void {
    this.registerFormChangesListener();

    if (this.mediumGroup) {
      this.updateForm();
    } else {
      this.mediumGroup = new MediumGroupFullDTO();
    }
    this.loading = false;
  }

  private registerFormChangesListener() {
    this.Name.valueChanges.subscribe(value => {
      this.mediumGroup.name = value;
    });
    this.Description.valueChanges.subscribe(value => {
      this.mediumGroup.description = value;
    });
  }

  updateForm() {
    this.Name.setValue(this.mediumGroup.name);
    this.Name.markAsTouched();
    this.Description.setValue(this.mediumGroup.description);
    this.Description.markAsTouched();
  }

  updateMediumGroupCall() {
    if (!this.mediumGroup.id) {
      if (this.selectedFolder) {
        this.mediumGroup.folder = this.selectedFolder;
      }
      this.api
        .mm_MediumGroup_create(this.customer.id, this.mediumGroup)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            this.mediumGroup = data;
            this.mediumGroupChangedEmitter.emit(this.mediumGroup);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    } else {
      this.api
        .mm_MediumGroup_edit(this.mediumGroup)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            this.mediumGroup = data;
            this.mediumGroupChangedEmitter.emit(this.mediumGroup);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  selectCompany() {
    this.modal
      .showNavigationModal({
        entryComponent: { value: CompaniesComponent, data: { toggleContext: 'hasMediumGroups' } },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: CompanyDTO) => {
        if (result) {
          this.customer = result;
        } else {
          this.customer = null;
        }
      })
      .catch(() => {});
  }
}
